module.exports = __webpack_public_path__ + "static/media/Luxury_Residential.eaead589.png";